export const normalizeApolloError = (result: any): Error | undefined => {
  if (result?.error instanceof Error) return result.error;
  if (Array.isArray(result?.errors) && result.errors.length > 0) {
    const msg = result.errors.map((e: any) => e.message ?? String(e)).join("; ");
    return new Error(msg);
  }
  return undefined;
};
